"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionTitle = exports.AccordionBody = exports.Accordion = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactstrap = require("reactstrap");
var _Icon = require("../../components/Icon");
require("./style.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let titleIndex = 0;
const AccordionTitle = props => {
  const inputEl = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (props.defaultOpen && inputEl) {
      inputEl.current.click();
    }
  }, [inputEl]);
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: inputEl,
    className: `accordion__title accordion__title-${props.dataKey == props.eleIndex ? 'up' : 'down'}`,
    "data-key": props.eleIndex,
    onClick: props.toggle,
    style: {
      ...props.style
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "accordion__title--content"
  }, props.children), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: ['fas', 'chevron-down'],
    className: "accordion__title--icon"
  }));
};
exports.AccordionTitle = AccordionTitle;
const AccordionBody = props => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "accordion__wrapper"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Collapse, {
    className: "accordion--body",
    isOpen: props.dataKey == props.eleIndex,
    style: {
      ...props.style
    }
  }, props.children));
};
exports.AccordionBody = AccordionBody;
const Accordion = props => {
  titleIndex = 0;
  const [key, setKey] = (0, _react.useState)('');
  const toggle = event => {
    setKey(event.target.getAttribute('data-key') === key ? '' : event.target.getAttribute('data-key'));
  };
  const children = _react.default.Children.map(props.children, (child, index) => {
    if (index % 2 === 0) {
      titleIndex++;
    }
    return /*#__PURE__*/_react.default.cloneElement(child, {
      toggle: toggle,
      dataKey: key,
      eleIndex: titleIndex
    });
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "accordion",
    style: {
      ...props.style
    }
  }, children);
};
exports.Accordion = Accordion;